import { z } from 'zod';

export const PASSWORD_MIN_LENGTH = 8;
// bcrypt ignores everything past 72 bytes, and a diacritic takes two of them.
const PASSWORD_MAX_BYTES = 72;

export const changePasswordSchema = z
  .object({
    currentPassword: z.string().min(1),
    newPassword: z
      .string()
      .min(PASSWORD_MIN_LENGTH)
      .refine(value => /\p{L}/u.test(value) && /\d/.test(value), { params: { i18n: 'custom.passwordLetterAndDigit' } })
      .refine(value => new TextEncoder().encode(value).length <= PASSWORD_MAX_BYTES, {
        params: { i18n: 'custom.passwordTooLong' },
      }),
    confirmPassword: z.string().min(1),
  })
  .refine(values => values.newPassword !== values.currentPassword, {
    path: ['newPassword'],
    params: { i18n: 'custom.samePassword' },
  })
  .refine(values => values.confirmPassword === values.newPassword, {
    path: ['confirmPassword'],
    params: { i18n: 'custom.notMatchingPasswords' },
  });

export type ChangePasswordSchema = z.infer<typeof changePasswordSchema>;

export const changePasswordDefaultValues: ChangePasswordSchema = {
  currentPassword: '',
  newPassword: '',
  confirmPassword: '',
};
